export const APP_SETTINGS_STATE_RECEIVED = "APP_SETTINGS_STATE_RECEIVED";
export const LOCAL_APP_SETTINGS_UPDATED = "LOCAL_APP_SETTINGS_UPDATED";
